module.exports = __webpack_public_path__ + "static/img/swipe-1.c54ee3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneHomePage/swipe-1.png
// module id = wysw
// module chunks = 0